import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Routes from './Routes';
import Contact from './Contact';
import Footer from './Footer';
import '../styles/Main.css';

function ContactPage() {
    return (
        <>
            <Helmet>
                <title>Kontakt | RiktigtRent - Boka städ i Linköping</title>
                <meta
                    name="description"
                    content="Kontakta RiktigtRent för företagsstäd, hemstäd och flyttstäd i Linköping och Östergötland. Boka konsultation eller ställ en fråga."
                />
                <meta
                    name="summary"
                    content="Kontakt med RiktigtRent: boka konsultation eller ställ frågor om företagsstäd, hemstäd och flyttstäd i Linköping."
                />
                <meta property="og:title" content="Kontakt - RiktigtRent" />
                <meta
                    property="og:description"
                    content="Boka städ eller fråga oss om företagsstäd, hemstäd och flyttstäd i Linköping och Östergötland."
                />
            </Helmet>
            <header className="app-header">
                <Routes />
            </header>
            <main>
                <div className="contact-back-row">
                    <Link className="contact-back" to="/" aria-label="Tillbaka till startsidan">← Tillbaka</Link>
                </div>
                <Contact />
                <Footer showIntro={false} />
            </main>
        </>
    );
}

export default ContactPage;
